import {
  AppBar,
  Toolbar,
  Typography,
  Tooltip,
  IconButton,
  MenuItem,
  Menu,
  Grid,
} from "@mui/material";
import { Box, Container } from "@mui/system";
import React, { useEffect, useState } from "react";

import { styled } from "@mui/material/styles";
import Badge from "@mui/material/Badge";
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";

import UserAvatar from "../components/UserAvatar";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import {
  MenuOpen as MenuOpenIcon,
  Menu as MenuIcon,
} from "@mui/icons-material";
// import MenuIcon from '@mui/icons-material/Menu';

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#44b700",
    color: "#44b700",
    boxShadow: `0 0 0 2px ${theme.palette.background.paper}`,
    "&::after": {
      position: "absolute",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      borderRadius: "50%",
      animation: "ripple 1.2s infinite ease-in-out",
      border: "1px solid currentColor",
      content: '""',
    },
  },
  "@keyframes ripple": {
    "0%": {
      transform: "scale(.8)",
      opacity: 1,
    },
    "100%": {
      transform: "scale(2.4)",
      opacity: 0,
    },
  },
}));

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
}));

function Header(props) {
  const [appBarPosition, setAppBarPosition] = useState("static");
  const settings = ["Profile", "Account", "Dashboard", "Logout"];
  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  //   const [menuOpenedFlag, setMenuOpenedFlag] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setUserName(user.name);
      setUserEmail(user.email);
    }

    function handleTransparentNavbar() {
      setAppBarPosition("sticky");
      if (window.scrollY === 0) {
        setAppBarPosition("static");
      }
    }

    window.addEventListener("scroll", handleTransparentNavbar);

    return () => true;
  }, []);

  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const [anchorElNotification, setAnchorElNotification] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleOpenNotificationMenu = (event) => {
    setAnchorElNotification(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  const handleCloseNotificationMenu = () => {
    setAnchorElNotification(null);
  };

  return (
    <>
      <AppBar className={`appbar-design ${appBarPosition}`}>
        {/* <Container maxWidth="xl"> */}
        <Toolbar disableGutters>
          <Typography
            variant="h6"
            fontWeight="700"
            fontSize="1rem"
            sx={{
              mr: 2,
              display: { xs: "none", md: "none" },
              fontWeight: 700,
              color: "inherit",
              textDecoration: "none",
            }}
          >
            Dashboard
          </Typography>
          <Box
            sx={{
              flexGrow: 1,
              // display: { xs: "none", md: "flex" }
            }}
          ></Box>

          <Box sx={{ flexGrow: 0 }}>
            <Grid
              display={`flex`}
              alignItems={`center`}
              gap={`15px`}
              className="menu-bar"
            >
              {!props.isVendorView && (
                props.menuOpenedFlag ? (
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={() => props.menuAction()}
                    color="inherit"
                    className="btn"
                  >
                    <MenuIcon />
                  </IconButton>
                ) : (
                  <IconButton
                    size="large"
                    aria-label="account of current user"
                    aria-controls="menu-appbar"
                    aria-haspopup="true"
                    onClick={() => props.menuAction()}
                    color="inherit"
                    className="btn"
                  >
                    <MenuOpenIcon />
                  </IconButton>
                )
              )}

              {/* <Tooltip title="Notification">
                <Stack
                  direction="row"
                  spacing={2}
                  onClick={handleOpenNotificationMenu}
                >
                  <StyledBadge
                    overlap="circular"
                    anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                    variant="dot"
                  >
                    <CircleNotificationsIcon sx={{ fontSize: 40 }} />
                  </StyledBadge>
                </Stack>
              </Tooltip> */}
              {!props.isVendorView ? (
                <Tooltip >
                  <Grid
                    onClick={handleOpenUserMenu}
                    sx={{ p: 0 }}
                    display="flex"
                    alignItems="center"
                  >
                    <Typography
                      fontWeight={600}
                      fontSize="1rem"
                    // sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
                    >
                      Hi, {userName}
                    </Typography>
                    <UserAvatar name={userName} />
                  </Grid>
                </Tooltip>
              ) : (
                <></>
              )}
            </Grid>
            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              // anchorEl={anchorElUser}
              // anchorOrigin={{
              //   vertical: "top",
              //   horizontal: "right",
              // }}
              // keepMounted
              // transformOrigin={{
              //   vertical: "top",
              //   horizontal: "right",
              // }}
              // open={Boolean(anchorElUser)}
              // onClose={handleCloseUserMenu}
              className={`profile-setting`}
            >
              <Grid className="profile-name">
                <UserAvatar name={userName} />
                <Typography
                  fontWeight={600}
                  fontSize="1rem"
                  // sx={{ flexGrow: 1, display: { xs: "none", md: "flex" } }}
                >
                  Hi, {userName}
                </Typography>
                <Typography fontSize="0.85rem">{userEmail}</Typography>
              </Grid>
              <hr className="hrLine" />
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseUserMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>

            {/* Notification Start */}

            <Menu
              sx={{ mt: "45px" }}
              id="menu-appbar"
              anchorEl={anchorElNotification}
              anchorOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              keepMounted
              transformOrigin={{
                vertical: "top",
                horizontal: "right",
              }}
              open={Boolean(anchorElNotification)}
              onClose={handleCloseNotificationMenu}
              className={`profile-setting`}
            >
              <hr className="hrLine" />
              {settings.map((setting) => (
                <MenuItem key={setting} onClick={handleCloseNotificationMenu}>
                  <Typography textAlign="center">{setting}</Typography>
                </MenuItem>
              ))}
            </Menu>

            {/* Notification End */}
          </Box>
        </Toolbar>
        {/* </Container> */}
      </AppBar>
    </>
  );
}

export default Header;
